module.exports = __webpack_public_path__ + "img/SM.bdd98917.svg";